module.exports = __webpack_public_path__ + "static/asset_cat-f1c68bf2b2d5f4acd80451e1c7f55f86.svg";